<template>
  <div class="p-6 modal-container">
    <form data-vv-scope="edit-device" class="space-y-8">
      <!-- Horizontal layout wrapper -->

      <div class="flex flex-col md:flex-row md:space-x-8">
        <!-- LEFT: General Settings -->

        <div class="md:w-1/2 space-y-4">
          <h3 class="text-lg font-semibold">General Settings</h3>

          <div class="flex justify-between items-center">
            <label class="vs-input--label">Ask Customer Name</label>

            <vx-tooltip text="Enable to request the customer's name">
              <vs-switch v-model="portalConfig.name" />
            </vx-tooltip>
          </div>

          <div class="flex justify-between items-center">
            <label class="vs-input--label">Ask Destination</label>

            <vx-tooltip text="Enable to request the destination address">
              <vs-switch v-model="portalConfig.destination" />
            </vx-tooltip>
          </div>

          <div class="flex justify-between items-center">
            <label class="vs-input--label">Ask Phone Number</label>

            <vx-tooltip text="Enable to request the customer's phone number">
              <vs-switch v-model="portalConfig.phone" />
            </vx-tooltip>
          </div>

          <div class="flex justify-between items-center">
            <label class="vs-input--label">Allow Schedule Booking</label>

            <vx-tooltip text="Enable customers to schedule bookings in advance">
              <vs-switch v-model="portalConfig.schedule_booking" />
            </vx-tooltip>
          </div>

          <div class="flex justify-between items-center">
            <label class="vs-input--label">Allow Additional Notes</label>

            <vx-tooltip text="Enable a text box for customers to leave notes">
              <vs-switch v-model="portalConfig.allow_notes" />
            </vx-tooltip>
          </div>
        </div>

        <!-- RIGHT: Vehicle Capabilities -->

        <div class="md:w-1/2">
          <h3 class="text-lg font-semibold mb-4">Vehicle Capabilities</h3>

          <v-select
            class="w-full"
            :options="vehicleOptions"
            v-model="parsedCapabilities"
            :multiple="true"
            placeholder="Select one or more vehicle types"
            :reduce="(option) => option.id"
          />

          <span class="text-danger text-sm mt-2" v-show="errors.has('edit-device.capabilities')">
            {{ errors.first('edit-device.capabilities') }}
          </span>
        </div>
      </div>

      <!-- Divider -->

      <hr class="my-6" />

      <!-- Submit Button -->

      <div class="flex justify-center">
        <vs-button @click.prevent="updateConfig()" class="px-6 py-2 text-base font-medium">
          Update Settings
        </vs-button>
      </div>
    </form>
  </div>
</template>

<script>
import { _updatePortalSettings } from '@/services/Venue'

import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect,
  },

  computed: {
    portalConfig: {
      get() {
        return this.$store.state.portalModule.config
      },
    },

    portal: {
      get() {
        return this.$store.state.portalModule
      },
    },

    parsedCapabilities: {
      get() {
        try {
          return JSON.parse(this.portal.capabilities || '[]')
        } catch (error) {
          console.error('Failed to parse capabilities:', error)

          return []
        }
      },

      set(value) {
        // Save back as stringified value

        this.portal.capabilities = JSON.stringify(value)
      },
    },
  },

  data() {
    return {
      vehicleOptions: [
        {
          label: 'Standard (Estate)', // Estate

          id: 4,

          // id : 4 for prod
        },

        {
          label: '6 Seater',

          id: 1,

          // id : 6 for prod
        },

        {
          label: '8 Seater',

          id: 3,

          // id : 3 for prod
        },

        {
          label: 'Airport',

          id: 25,

          // id: 25, for prod
        },

        {
          label: 'Executive',

          id: 10,

          // id: 5, for prod
        },

        {
          label: 'Saloon',

          id: 2,

          // id: 9, for prod
        },
      ],

      selectedCapabilities: [], // local array for v-select binding
    }
  },

  methods: {
    updateConfig() {
      this.portal.config = this.portalConfig

      this.$validator.validateAll('edit-device').then((result) => {
        if (result) {
          this.$vs.loading()

          _updatePortalSettings(
            this.portal.venue_id,

            this.portal.id,

            this.portal
          ).then((response) => {
            this.$vs.loading.close()

            this.$emit('updateConfigParent', response)

            this.$vs.notify({
              title: response.data.responseTitle,

              text: response.data.responseMessage,

              iconPack: 'feather',

              icon: 'icon-check-circle',

              color: 'success',
            })
          })
        }
      })
    },
  },
}
</script>



<style scoped>
.demo-alignment li {
  list-style: none;
}

.vs-input--label {
  font-weight: 400;
  font-size: small;
}

.settings-left,
.settings-right {
  display: flex;
  flex-direction: column;
}

.vx-tooltip-content {
  z-index: 9999 !important;
}

.modal-container {
  overflow: visible !important;
}

@media (min-width: 768px) {
  .settings-left,
  .settings-right {
    width: 48%;
  }

  .vs-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
</style>
